import api from '../../api/api'
import { connect } from 'react-redux'
import { PulseLoader } from 'halogen'
import React, { Component } from 'react'
import { browserHistory } from 'react-router'
import { appendToFormData, debounce } from '../../helpers/utility'
import { Row, Grid, Form, FormGroup, InputGroup } from '@sketchpixy/rubix'
import AutoCompleteInput from '../common/AutoCompleteInput'
import sampleSchoolDocument from './sampleForm.docx'
import {
  Field,
  reduxForm,
  SubmissionError,
  reset,
  getFormValues,
  change,
} from 'redux-form'
import {
  SIGNUP_REQUEST,
  FETCH_STATES_REQUEST,
  FETCH_DISTRICTS_REQUEST,
} from '../../actions/actions'
import * as MabnaButton from '../common/Button/Button'

const styles = {
  wrapper: {
    padding: 25,
    paddingTop: 0,
    paddingBottom: 0,
    margin: 'auto',
    marginBottom: 25,
    marginTop: 25,
  },
  loading: {
    height: 45,
    display: 'flex',
    alignContent: 'center',
    alignItems: 'center',
  },
}

// const genderOptions = [
//   { id: 'girl', name: 'مرکز آموزشی دخترانه' },
//   { id: 'boy', name: 'مرکز آموزشی پسرانه' },
//   { id: 'both', name: 'مرکز آموزشی مشترک' }
// ]
const formSelector = 'SchoolSignup'

export const schoolTypeOptions = [
  { id: 'state', name: 'دولتی' },
  { id: 'private', name: 'غیر دولتی' },
  { id: 'trustees', name: 'هیات امنایی' },
  { id: 'special', name: 'نمونه دولتی' },
  { id: 'shahed', name: 'شاهد' },
  { id: 'boarding', name: 'شبانه روزی' },
  { id: 'nodet', name: 'استعدادهای درخشان' },
  { id: 'abroad', name: 'ایرانی خارج از کشور' },
]

export const schoolTypeOptionsWithUnknown = [
  { id: '-1', name: 'نامشخص' },
  ...schoolTypeOptions,
]
// just a random number never used as select option id
const NONE = -8756

class SchoolSignup extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isLoadingDistricts: false,
      districts: [],
      loadingSchoolInfo: false,
      schoolInfo: null,
      schoolsList: [],
      instituteTypes: [],
      schoolOptionId: NONE,
    }
  }

  componentWillMount = () => {
    this.props.dispatch({
      type: FETCH_STATES_REQUEST,
    })
    this.fetchInstituteTypes()
  }

  componentWillUpdate(nextProps, nextState) {
    this.clearSchoolIfStateOrDistrictChanged(nextProps)
    this.updateDistrictsIfNeeded(nextProps)
    this.updateShoolInfoBasedOnSchoolCodeIfNeeded(nextProps)
  }

  isNotDefaultValue = value => value && value !== -1 && value !== '-1'

  updateDistrictsIfNeeded = nextProps => {
    const { formValues: nextFormValues = {} } = nextProps
    const { state } = nextFormValues

    const shouldCare = this.isNotDefaultValue(state)
    if (!shouldCare) return

    const { formValues: currentFormValues = {} } = this.props

    const itAffectsDistrictsList = state !== currentFormValues.state

    if (itAffectsDistrictsList) {
      this.fetchDistricts(state)
    }
  }

  clearSchoolCode = () => this.props.dispatch(change(formSelector, 'school_code', ''))

  clearSchool = () => this.props.dispatch(change(formSelector, 'first_name', ''))

  fetchDistricts = stateId => {
    this.setState({ isLoadingDistricts: true })

    new Promise((resolve, reject) => {
      this.props.dispatch({
        type: FETCH_DISTRICTS_REQUEST,
        stateId,
        resolve,
        reject,
      })
    })
      .then(districts => {
        this.setState({
          isLoadingDistricts: false,
          districts: districts,
        })
      })
      .catch(err => {
        this.setState({ isLoadingDistricts: false })
        console.log(err)
      })
  }

  clearSchoolIfStateOrDistrictChanged = nextProps => {
    const { formValues: nextFormValues = {} } = nextProps
    const { formValues: currentFormValues = {} } = this.props

    const { state, district } = nextFormValues
    const { state: currentState, district: currentDistrict } = currentFormValues
    // school
    if ( state !== currentState || district !== currentDistrict ) {
      this.clearSchool()
    }
  }

  updateShoolInfoBasedOnSchoolCodeIfNeeded = nextProps => {
    const { formValues: nextValues = {} } = nextProps
    const { school_code } = nextValues

    const { formValues: currentValues = {} } = this.props

    if (school_code !== currentValues.school_code) {
      this.fetchSchoolInfoByCode(school_code)
    }
  }

  setInstituteLoading = state => this.setState({ loadingInstituteOptions: state })

  setSchoolOptionId = id => this.setState({ schoolOptionId: id })

  fetchInstituteTypes = () => {
    this.setInstituteLoading(true)

    const toSelectOptions = item => {
      if (item.slug && item.slug === 'school') {
        this.setSchoolOptionId(item.id)
      }

      return { id: item.id, name: item.title, slug: item.slug }
    }
    const mapToOptions = items => Array.isArray(items)? items.map(toSelectOptions) : []

    const setFailedAfterRequest = res => {
      console.log(res)
      this.setInstituteLoading(false)
    }

    const setSuccessfulAfterRequest = res => {
      this.setState({
        instituteTypes: mapToOptions(res.data.data.institute_types)
      })
      this.setInstituteLoading(false)
    }

    api.getInstituteTypes()
      .then( res => {
        res.status < 400 ? setSuccessfulAfterRequest(res) : setFailedAfterRequest()

      }).catch( error => {
        setFailedAfterRequest(error)
      })

  }

  fetchSchoolInfoByCode = debounce(school_code => {
    this.setState({ loadingSchoolInfo: true })

    const setFailedStateAfterRequest = () => {
      this.setState({ loadingSchoolInfo: false, schoolInfo: null })
    }

    const setSuccessfulStateAfterRequest = res => {
      const schoolInfo = res.data.data.school
      const schoolName = schoolInfo.school_name

      this.setState({ loadingSchoolInfo: false, schoolInfo })
      this.props.dispatch(change(formSelector, 'first_name', schoolName))
    }

    api
      .fetchSchoolInfoByCode(school_code)
      .then(res => {
        res.status < 400
          ? setSuccessfulStateAfterRequest(res)
          : setFailedStateAfterRequest()
      })
      .catch(error => {
        setFailedStateAfterRequest()
        console.log(error)
      })
  }, 500)

  searchSchools = data => {
    if (!data) return

    const handle = {
      fail: error => {
        this.setState({ schoolsList: [] })
        console.log(error)
      },
      success: res => {
        const mapper = school => ({
          name: school.school_name,
          value: school.school_name,
        })

        const schoolsList = res.data.data.schools.map(mapper)

        this.setState({ schoolsList })
      },
    }

    api
      .fetchSchools(appendToFormData(data))
      .then(res => (res.status < 400 ? handle.success(res) : handle.fail()))
      .catch(handle.fail)
  }

  triggerSchoolSearch = debounce(first_name => {
    const { formValues: { state, district } = {} } = this.props
    this.searchSchools({ school_name: first_name, district, state })
  }, 450)

  usernameInput = ({ input, meta: { touched, error }, ...custom }) => {
    let hasError = touched && error !== undefined
    return (
      <FormGroup controlId="username">
        <div className="form-error">{hasError && error}</div>
        <InputGroup bsSize="large">
          <InputGroup.Addon>
            <i className="fa fa-user-circle-o" aria-hidden="true" />
          </InputGroup.Addon>
          <input
            type="text"
            className="border-focus-blue"
            placeholder="نام کاربری"
            {...input}
            {...custom}
          />
        </InputGroup>
      </FormGroup>
    )
  }

  passwordInput = ({ input, meta: { touched, error }, ...custom }) => {
    let hasError = touched && error !== undefined
    return (
      <FormGroup controlId="password">
        <div className="form-error">{hasError && error}</div>
        <InputGroup bsSize="large">
          <InputGroup.Addon>
            <i className="fa fa-key" aria-hidden="true" />
          </InputGroup.Addon>
          <input
            type="password"
            className="border-focus-blue"
            placeholder="گذرواژه (اعداد و حروف)"
            {...input}
            {...custom}
          />
        </InputGroup>
      </FormGroup>
    )
  }

  confirmPasswordInput = ({ input, meta: { touched, error }, ...custom }) => {
    let hasError = touched && error !== undefined
    return (
      <FormGroup controlId="confirmPassword">
        <div className="form-error">{hasError && error}</div>
        <InputGroup bsSize="large">
          <InputGroup.Addon>
            <i className="fa fa-key" aria-hidden="true" />
          </InputGroup.Addon>
          <input
            type="password"
            className="border-focus-blue"
            placeholder="تایید گذرواژه"
            {...input}
            {...custom}
          />
        </InputGroup>
      </FormGroup>
    )
  }

  firstName = ({ input, meta: { touched, error }, disabled }) => {
    let hasError = touched && error !== undefined
    return (
      <FormGroup controlId="firstName">
        <div className="form-error">{hasError && error}</div>
        <InputGroup bsSize="large">
          <InputGroup.Addon>
            <i className="fa fa-address-card" aria-hidden="true" />
          </InputGroup.Addon>
          <input
            type="text"
            disabled={disabled}
            className="border-focus-blue"
            placeholder="نام مرکز آموزشی"
            {...input}
          />
        </InputGroup>
      </FormGroup>
    )
  }

  email = ({ input, meta: { touched, error }, ...custom }) => {
    let hasError = touched && error !== undefined
    return (
      <FormGroup controlId="email">
        <div className="form-error">{hasError && error}</div>
        <InputGroup bsSize="large">
          <InputGroup.Addon>
            <i className="fa fa-envelope" aria-hidden="true" />
          </InputGroup.Addon>
          <input
            type="email"
            className="border-focus-blue"
            placeholder="ایمیل"
            {...input}
            {...custom}
          />
        </InputGroup>
      </FormGroup>
    )
  }

  mobile = ({ input, meta: { touched, error }, ...custom }) => {
    let hasError = touched && error !== undefined
    return (
      <FormGroup controlId="mobile">
        <div className="form-error">{hasError && error}</div>
        <InputGroup bsSize="large">
          <InputGroup.Addon>
            <i className="fa fa-mobile" aria-hidden="true" />
          </InputGroup.Addon>
          <input
            type="number"
            className="border-focus-blue"
            placeholder="تلفن همراه کاربر سامانه"
            {...input}
            {...custom}
          />
        </InputGroup>
      </FormGroup>
    )
  }

  landLinePhone = ({ input, meta: { touched, error }, ...custom }) => {
    let hasError = touched && error !== undefined
    return (
      <FormGroup controlId="landLinePhone">
        <div className="form-error">{hasError && error}</div>
        <InputGroup bsSize="large">
          <InputGroup.Addon>
            <i className="fa fa-phone" aria-hidden="true" />
          </InputGroup.Addon>
          <input
            type="number"
            className="border-focus-blue"
            placeholder="شماره تلفن مرکز"
            {...input}
            {...custom}
          />
        </InputGroup>
      </FormGroup>
    )
  }

  nationalNumber = ({ input, meta: { touched, error }, ...custom }) => {
    let hasError = touched && error !== undefined
    return (
      <FormGroup controlId="nationalNumber">
        <div className="form-error">{hasError && error}</div>
        <InputGroup bsSize="large">
          <InputGroup.Addon>
            <i className="fa fa-id-card-o" aria-hidden="true" />
          </InputGroup.Addon>
          <input
            type="text"
            className="border-focus-blue"
            placeholder="شماره ملی"
            {...input}
            {...custom}
          />
        </InputGroup>
      </FormGroup>
    )
  }

  address = ({ input, meta: { touched, error }, ...custom }) => {
    let hasError = touched && error !== undefined
    return (
      <FormGroup controlId="address">
        <div className="form-error">{hasError && error}</div>
        <InputGroup bsSize="large">
          <InputGroup.Addon>
            <i className="fa fa-map-marker" aria-hidden="true" />
          </InputGroup.Addon>
          <textarea
            type="text"
            className="border-focus-blue"
            placeholder="نشانی"
            {...input}
            {...custom}
          />
        </InputGroup>
      </FormGroup>
    )
  }

  info = ({ input, meta: { touched, error }, ...custom }) => {
    let hasError = touched && error !== undefined
    return (
      <FormGroup controlId="info">
        <div className="form-error">{hasError && error}</div>
        <InputGroup bsSize="large">
          <InputGroup.Addon>
            <i className="fa fa-info" aria-hidden="true" />
          </InputGroup.Addon>
          <textarea
            type="text"
            className="border-focus-blue"
            placeholder="توضیحات"
            {...input}
            {...custom}
          />
        </InputGroup>
      </FormGroup>
    )
  }

  postCode = ({ input, meta: { touched, error }, ...custom }) => {
    let hasError = touched && error !== undefined
    return (
      <FormGroup controlId="info">
        <div className="form-error">{hasError && error}</div>
        <InputGroup bsSize="large">
          <InputGroup.Addon>
            <i className="fa fa-info" aria-hidden="true" />
          </InputGroup.Addon>
          <input
            type="number"
            className="border-focus-blue"
            placeholder="کد پستی"
            {...input}
            {...custom}
          />
        </InputGroup>
      </FormGroup>
    )
  }

  managerName = ({ input, meta: { touched, error }, ...custom }) => {
    let hasError = touched && error !== undefined
    return (
      <FormGroup controlId="info">
        <div className="form-error">{hasError && error}</div>
        <InputGroup bsSize="large">
          <InputGroup.Addon>
            <i className="fa fa-info" aria-hidden="true" />
          </InputGroup.Addon>
          <input
            type="text"
            className="border-focus-blue"
            placeholder="نام و نام خانوادگی مدیر مرکز"
            {...input}
            {...custom}
          />
        </InputGroup>
      </FormGroup>
    )
  }

  operatorName = ({ input, meta: { touched, error }, ...custom }) => {
    let hasError = touched && error !== undefined
    return (
      <FormGroup controlId="info">
        <div className="form-error">{hasError && error}</div>
        <InputGroup bsSize="large">
          <InputGroup.Addon>
            <i className="fa fa-info" aria-hidden="true" />
          </InputGroup.Addon>
          <input
            type="text"
            className="border-focus-blue"
            placeholder="نام و نام خانوادگی کاربر سامانه"
            {...input}
            {...custom}
          />
        </InputGroup>
      </FormGroup>
    )
  }

  schoolCode = ({ input, meta: { touched, error } }) => {
    let hasError = touched && error !== undefined
    return (
      <FormGroup controlId="info">
        <div className="form-error">{hasError && error}</div>
        <InputGroup bsSize="large">
          <InputGroup.Addon>
            <i className="fa fa-info" aria-hidden="true" />
          </InputGroup.Addon>
          <input
            type="number"
            className="border-focus-blue"
            placeholder="کد سناد"
            {...input}
          />
        </InputGroup>
      </FormGroup>
    )
  }

  documentFile = ({ input, meta: { touched, error, warning } }) => {
    let hasError = touched && error !== undefined
    const fileName = input.value && input.value.length > 0 ? input.value[0].name : null
    delete input.value // can not set value of an file input

    return (
      <FormGroup controlId="info">
        <div className="form-error">{hasError && error}</div>

        <div className="form-warning">
          <a href={sampleSchoolDocument}>دریافت نمونه برگه تاییدیه مرکز آموزشی</a>
        </div>

        <InputGroup bsSize="large">
          <InputGroup.Addon>
            <i className="fa fa-info" aria-hidden="true" />
          </InputGroup.Addon>

          <input
            type="file"
            id="document-file"
            accept="image/*"
            className="border-focus-blue"
            placeholder="نام کاربر سامانه"
            {...input}
          />

          <label htmlFor="document-file">
            {fileName ? fileName : 'تصویر برگه تایید هویت مرکز آموزشی با مهر و امضای مدیر'}
          </label>
        </InputGroup>
      </FormGroup>
    )
  }

  selectInputCreator = settings => ({
    input,
    meta: { touched, error, warning },
    options,
    iconClassName,
  }) => {
    const hasError = touched && error
    const placeholder = settings.loading ? 'در حال بارگذاری ...' : settings.placeholder

    return (
      <FormGroup controlId="address">
        <div className="form-error">{hasError && error}</div>

        <InputGroup bsSize="large">
          <InputGroup.Addon>
            <i className={`fa ${iconClassName || 'fa-pencil'}`} aria-hidden="true" />
          </InputGroup.Addon>

          <select {...input} disabled={settings.disabled}>
            <option value={-1} disabled hidden>{placeholder}</option>

            {options.map(option => (
              <option key={option.id} value={option.id}>
                {option.name}
              </option>
            ))}
          </select>
        </InputGroup>
      </FormGroup>
    )
  }

  eduLevel = ({ input, meta: { touched, error }, levels }) => (
    <div>
      {touched && error && <div className="form-error">{error}</div>}

      <select {...input}>
        <option value={0}>دوره تحصیلی</option>

        {levels.map((level, i) => (
          <option key={i} value={level.id}>
            {level.name}
          </option>
        ))}
      </select>
    </div>
  )

  renderAutoComplete = ({
    input,
    meta: { touched, error },
    options,
    disabled,
    iconClassName,
  }) => {
    const hasError = Boolean(touched && error)
    const placeholder = 'نام مرکز'

    const onOptionSelection = value => {
      input.onChange(value.name)
    }

    const onTextChange = value => {
      input.onChange(value)
      this.triggerSchoolSearch(value)
    }

    return (
      <FormGroup controlId="address">
        <div className="form-error">{hasError && error}</div>

        <InputGroup bsSize="large">
          <InputGroup.Addon>
            <i className={`fa ${iconClassName || 'fa-pencil'}`} aria-hidden="true" />
          </InputGroup.Addon>

          <AutoCompleteInput
            {...input}
            onChange={onOptionSelection}
            disabled={disabled}
            placeholder={placeholder}
            options={options}
            onTextChange={onTextChange}
          />
        </InputGroup>
      </FormGroup>
    )
  }

  isSchool = () => {
    return this.props.formValues &&
      parseInt(this.props.formValues.institute_type) === this.state.schoolOptionId
  }

  removeUnsetSelectInputValues = form => {
    const cleanedForm = {}

    for (const field in form) {
      if (form[field] === -1 || form[field] === '-1') continue
      cleanedForm[field] = form[field]
    }

    return cleanedForm
  }

  handleFile = values => {
    // no files
    if (!values.certificate_document || values.certificate_document.length === 0) {
      return Object.assign({}, values, { certificate_document: undefined })
    }

    // at least one files
    if (values.certificate_document && values.certificate_document.length > 0) {
      const { certificate_document: fileList } = values
      return Object.assign({}, values, { certificate_document: fileList[0] })
    }

    // weird situation
    return values
  }

  onSubmit = values => {
    const { dispatch, updateParent } = this.props

    return new Promise((resolve, reject) => {
      const cleanedData = this.handleFile(this.removeUnsetSelectInputValues(values))
      let formData = appendToFormData(cleanedData)

      dispatch({
        type: SIGNUP_REQUEST,
        formData,
        resolve,
        reject,
        userType: 'SCHOOL',
      })
    })
      .then(data => {
        // if updateParent exists, it means the component is
        // embedded and should just call the callback
        if (!updateParent) {
          this.redirectAfterSignup()
          return
        }

        updateParent(data)
        dispatch(reset(formSelector))
      })
      .catch(response => {
        throw new SubmissionError({
          _error: response.general_errors[0],
          ...response.form_errors,
        })
      })
  }

  redirectAfterSignup = () => browserHistory.push('/signup/success')

  render() {
    const { handleSubmit, error, formValues = {} } = this.props

    const { state } = formValues

    const districtPlaceholder = `منطقه ${state ? '' : '(ابتدا استان را انتخاب کنید)'}`

    const nameIsDisabled = Boolean(this.state.schoolInfo)

    return (
      <div>
        <div style={styles.wrapper}>
          <Form onSubmit={handleSubmit(this.onSubmit)}>
            {/* <Field name="email" component={this.email} /> */}
            {/* <Field
              name="gender_group"
              component={this.selectInputCreator({
                placeholder: 'جنسیت مرکز آموزشی'
              })}
              options={genderOptions}
              iconClassName="fa-genderless"
            /> */}

            <fieldset>
              <legend>اطلاعات مرکز آموزشی</legend>

              <Field
                name="institute_type"
                component={this.selectInputCreator({
                  placeholder: 'نوع مرکز آموزشی'
                })}
                iconClassName="fa-info"
                options={this.state.instituteTypes}
              />

              {this.isSchool() && <Field name="school_code" component={this.schoolCode} />}

              <Field
                name="state"
                component={this.selectInputCreator({
                  placeholder: 'استان',
                })}
                options={this.props.states}
                iconClassName="fa-map-marker"
              />

              <Field
                name="district"
                component={this.selectInputCreator({
                  placeholder: districtPlaceholder,
                  disabled: this.state.districts.length === 0,
                  loading: this.state.isLoadingDistricts,
                })}
                options={this.state.districts}
                iconClassName="fa-map-marker"
              />

              {this.isSchool()
                ? <Field
                  name="first_name"
                  component={this.renderAutoComplete}
                  options={this.state.schoolsList}
                  disabled={nameIsDisabled}
                />
                : <Field name="first_name" component={this.firstName} />
              }
            </fieldset>

            {/* <Field
              name="school_type"
              component={this.selectInputCreator({
                placeholder: 'نوع مدرسه'
              })}
              options={schoolTypeOptions}
              iconClassName="fa-id-card"
            /> */}

            {/* <Field name="certificate_document" component={this.documentFile} /> */}

            <fieldset>
              <legend>اطلاعات تماس</legend>
              <Field name="landline_phone" component={this.landLinePhone} />

              <Field name="postal_code" component={this.postCode} />

              <Field name="address" component={this.address} />

            </fieldset>

            {/* <Field name="manager_name" component={this.managerName} /> */}

            <fieldset>
              <legend>اطلاعات کاربر</legend>
              <Field name="operator_name" component={this.operatorName} />
              <Field
                name="username"
                component={this.usernameInput}
                autoComplete="username"
              />
              <Field name="phone_number" component={this.mobile} />

              <Field name="password" component={this.passwordInput} />
              <Field name="confirm_password" component={this.confirmPasswordInput} />
            </fieldset>

            <FormGroup>
              <Grid>
                <Row style={{ textAlign: 'center', padding: '5px' }}>
                  {error && <strong>{error}</strong>}
                </Row>

                <Row>
                  <div className="auth-buttons-container">
                    {!this.props.aSyncCall ? (
                      <MabnaButton.Primary
                        style={{ marginLeft: 10, marginRight: 10 }}
                        buttonSize='large'
                        type="submit"
                        className=""
                      >
                        عضویت
                      </MabnaButton.Primary>
                    ) : (
                      <div style={styles.loading}>
                        <PulseLoader color="#275C8A" size="10px" />
                      </div>
                    )}

                    <MabnaButton.Primary
                      buttonSize='large'
                      className=""
                      outline
                      onClick={() => browserHistory.push('/')}
                    >
                      بازگشت
                    </MabnaButton.Primary>
                  </div>
                </Row>
              </Grid>
            </FormGroup>
          </Form>
        </div>
      </div>
    )
  }
}

const validate = values => {
  let errors = {}

  if (!values.institute_type || values.institute_type === -1 || values.institute_type === '-1') {
    errors.institute_type = 'نوع مرکز آموزشی اجباری است'
  }

  if (!values.username) {
    errors.username = 'نام کاربری اجباری است'
  }

  if (!values.last_name) {
    errors.last_name = 'نام خانوادگی اجباری است'
  }

  if (!values.first_name) {
    errors.first_name = 'نام اجباری است'
  }

  // if (!values.email) {
  //   errors.email = 'ایمیل اجباری است'
  // }

  if (parseInt(values.level, 10) === 0) {
    errors.level = 'انتخاب مقطع تحصیلی اجباری است'
  }

  if (!values.phone_number) {
    errors.phone_number = 'شماره موبایل اجباری است'
  }

  if (!values.password) {
    errors.password = 'گذرواژه اجباری است'
  }

  if (values.password !== values.confirm_password || !values.password) {
    errors.confirm_password = 'گذرواژه‌ها یکسان نیست'
  }

  if (!values.state || values.state === -1 || values.state === '-1') {
    errors.state = 'استان مرکز آموزشی الزامی است'
  }

  if (!values.district || values.district === -1 || values.district === '-1') {
    errors.district = 'منطقه مرکز آموزشی الزامی است'
  }

  if (!values.operator_name) {
    errors.operator_name = 'نام کابر سامانه الزامی است'
  }

  // if (!values.school_code) {
  //   errors.school_code = 'کد سناد الزامی است'
  // }

  return errors
}

SchoolSignup = reduxForm({
  form: formSelector,
  validate,
})(SchoolSignup)

const mapStateToProps = state => ({
  states: state.states,
  formValues: getFormValues(formSelector)(state),
  initialValues: {
    institute_type: -1,
    district: -1,
    state: -1,
  }
})

export default connect(mapStateToProps)(SchoolSignup)



// WEBPACK FOOTER //
// ./src/components/school/SchoolSignup.js